import * as types from "./types";

const mutations = {
    [types.LOADING_JOBCARD](state, value) {
        state.loading = value;
    },
    [types.GET_JOBCARD_LIST](state, jobcards) {
        state.jobcards = jobcards;
    },
    [types.GET_JOBCARD_DEMAND](state, jobDemand) {
        state.jobDemand = jobDemand;
    },
    [types.GET_JOBCARD_FILES](state, jobFile) {
        state.jobFile = jobFile;
    },
    [types.GET_JOBCARD_ID](state, jobId) {
        state.jobId = jobId;
    },
    [types.REMOVE_JOBCARD](state, id) {        
        state.jobcards = state.jobcards.filter((x) => x.id !== id);        
    },
    [types.ADD_JOBCARD](state, jobcards) {        
        state.jobcards.unshift(jobcards);
    },
    [types.UPDATE_JOBCARD](state, jobcards) {        
        const jobcardsIndex = state.jobcards.findIndex((x) => x.id === jobcards.id);
        state.jobcards[jobcardsIndex] = jobcards;        
    },
    [types.UPDATE_JOBCARD_STATUS](state, jobcards) {        
        const jobcardsIndex = state.jobcards.findIndex((x) => x.id === jobcards.id);
        state.jobcards[jobcardsIndex] = jobcards;        
    },
    [types.UPDATE_MULTIPLE_JOBCARD](state, jobcards) {
        jobcards.forEach((updateItem) => {
            const index = state.jobcards.findIndex((jobcard) => jobcard.id === updateItem.id);
            if (index !== -1) {
                state.jobcards[index].status = updateItem.status;
            }
        });
    },
    [types.GET_JOBCARD_PRIORITY](state, JobcardPriority) {
        state.JobcardPriority = JobcardPriority;
    },
    [types.ADD_JOBCARD_FILE](state, jobcardsFile) {      
        state.jobcards.unshift(jobcardsFile);
    },
    [types.ADD_JOBCARD_FILES](state, jobcardsFiles) {      
        state.jobcards.unshift(jobcardsFiles);
    },
    [types.REMOVE_JOBCARD_FILE](state, id) {      
        state.jobcards = state.jobcards.filter((x) => x.id !== id);        
    },
    [types.GET_JOBCARD_FILES_DOWNLOAD](state, id) {
        state.id = id;
    },
    [types.JOBCARD_GET_TIMESHEET_LIST](state, timesheetList){
        state.timesheetList = timesheetList;
    },
    [types.JOBCARD_ADD_TIMESHEET](state, timesheet){
        state.timesheetList.unshift(timesheet)
    },
};

export default mutations;